module.exports = __webpack_public_path__ + "0bdbb234ee7756e3c856343f87286ed2.png";